import Vue from 'vue';
import '@/self';
import App from './app';
import Copyright from '@/views/copyright';
import router from './router';
import '@/components';
import '@/http';
import '@/scss/index.scss';
import formatNum from './utils/formatNum';
import {pageKey, pid} from './pageKey';
import TasteFresh from '@/views/taste-fresh';

Vue.use(TasteFresh);

Vue.filter('formatNum', formatNum);
Vue.component('copyright', Copyright);

Vue.config.productionTip = false;

document.title = window.CONFIG.documentTitle;

function fluxCount(pagekey, pid) {
  window._jaq = window._jaq || []
  // 创建psa埋点
  window.PSAPROJECTID = pid
  window._jaq.push(['_setAccount', window.PSAPROJECTID])
  window._jaq.push(pagekey)
  ;(function () {
    var ja = document.createElement('script')
    ja.type = 'text/javascript'
    ja.async = true
    ja.src = '//storage.360buyimg.com/static-res/js/common/psa-ag-ctm-1.0.js' // +new Date().getTime();
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(ja, s)
  })()
}

const hash = window.location.hash.substring(1);
if (/^\/home/.test(hash)) {
  fluxCount(pageKey['/home'], pid);
} else if (/^\/auth/.test(hash)) {
  fluxCount(pageKey['/auth'], pid);
} else if (/^\/receive-code-failed/.test(hash)) {
  fluxCount(pageKey['/receive-code-failed'], pid);
} else if (/^\/status\/checking-end/.test(hash)) {
  fluxCount(pageKey['/status/checking-end'], pid);
} else if (/^\/status\/checking/.test(hash)) {
  fluxCount(pageKey['/status/checking'], pid);
} else if (/^\/status\/success/.test(hash)) {
  fluxCount(pageKey['/status/success'], pid);
} else if (/^\/status\/failed/.test(hash)) {
  fluxCount(pageKey['/status/failed'], pid);
} else {
  fluxCount(pageKey['/'], pid);
}

new Vue({
  windowCONFIG: window.CONFIG,
  router,
  render: h => h(App)
}).$mount('#app');
